import React from 'react';

import customIconFont from '@assets/fonts/magalu-icons.ttf';
import { createIconSetFromIcoMoon } from '@expo/vector-icons';
import { IconProps } from '@expo/vector-icons/build/createIconSet';

import icoMoonConfig from '../../selection.json';

const CustomIconSet = createIconSetFromIcoMoon(
  icoMoonConfig,
  'CustomMagaluFont',
  customIconFont
);

const CustomIcon: React.FC<IconProps<string>> = props => {
  return <CustomIconSet {...props} />;
};

export default CustomIcon;
